import { render } from "./AppNavigationHeader.vue?vue&type=template&id=4f512fd7&scoped=true"
import script from "./AppNavigationHeader.vue?vue&type=script&lang=js"
export * from "./AppNavigationHeader.vue?vue&type=script&lang=js"

import "./AppNavigationHeader.vue?vue&type=style&index=0&id=4f512fd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f512fd7"]])

export default __exports__